import type { Fase } from '../lib/tipos'

/**
 * Las fases de la llamada.
 *
 * Con `alElegir` se puede pulsar en una para verla: es la navegación que pidió
 * José el 15 de octubre para los contratos ya lanzados («poder navegar entre las
 * pestañas anteriores»). Mientras la llamada está abierta no se pasa, y entonces
 * la barra es solo un indicador, como antes.
 */
export function BarraFases({
  fases,
  actual,
  alElegir,
}: {
  fases: Array<{ codigo: Fase; etiqueta: string }>
  actual: Fase
  alElegir?: (fase: Fase) => void
}) {
  const posicion = fases.findIndex((fase) => fase.codigo === actual)

  return (
    <ol className="flex flex-wrap items-center gap-1 text-xs">
      {fases.map((fase, indice) => {
        const hecha = indice < posicion
        const esActual = indice === posicion
        const clases = `rounded-full px-2.5 py-1 font-medium transition ${
          esActual
            ? 'bg-marca-700 text-white'
            : hecha
              ? 'bg-marca-50 text-marca-700 dark:bg-marca-700/20 dark:text-marca-100'
              : 'bg-slate-100 text-slate-400 dark:bg-slate-800'
        }`

        return (
          <li key={fase.codigo}>
            {alElegir === undefined ? (
              <span className={clases}>
                {indice}. {fase.etiqueta}
              </span>
            ) : (
              <button onClick={() => alElegir(fase.codigo)} className={clases}>
                {indice}. {fase.etiqueta}
              </button>
            )}
          </li>
        )
      })}
    </ol>
  )
}
